<app-view-item *ngIf="readonly" [text]="selected?.code" [borderless]="borderless"></app-view-item>

<nz-select #selector *ngIf="!readonly" nzShowSearch nzServerSearch ngDefaultControl [nzAllowClear]="allowClear"
  [nzBackdrop]="addBackdrop" [nzFilterOption]="nzFilterOption" (nzOnSearch)="search($event)" (nzOpenChange)="search('')"
  (nzScrollToBottom)="loadMore()" [nzCustomTemplate]="displayTpl" [(ngModel)]="value"
  (ngModelChange)="valueChanged($event)" [nzDropdownMatchSelectWidth]="false" [nzBorderless]="borderless"
  (keydown)="handleKeyDown($event)" (click)="handleClick($event)" class="width-100 dropdownSelect">
  <ng-template #displayTpl let-selected>
    <span>{{ selected.nzLabel }}</span>
  </ng-template>

  <nz-option [nzValue]="''" nzCustomContent>
    <div class="text-center">
      <button type="button" nz-button nzType="primary" class="add-new-button" (click)="$event.stopPropagation(); addNew($event)" acl="'tariffcode.create'">
        <span nz-icon nzType="plus"></span>
        {{ instantData ? ' Add New \''+ instantData +'\'' : ' Add New' }}
      </button>
    </div>
  </nz-option>

  <ng-container *ngFor="let o of list">
    <nz-option *ngIf="!searching" [nzValue]="getValue(o)" [nzLabel]="o.code" nzCustomContent>
      <div>
        <strong>{{ o.code }}</strong>
        :
        <span> {{ o.description }}</span>
      </div>
    </nz-option>
  </ng-container>
</nz-select>

<ng-template #loadingTpl>
  <div *ngIf="searching">
    <nz-spin></nz-spin>
    Loading
  </div>
</ng-template>

<app-tariff-code-edit-modal (selectTariffCode)="selectTariffCode($event)"></app-tariff-code-edit-modal>